// extracted by mini-css-extract-plugin
export default {"container":"MJ-z","error":"NJ-z","disabled":"OJ-z","submit":"PJ-z","option":"QJ-z","success":"RJ-z","failure":"SJ-z"};